import React from "react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";

export function ForbiddenPage() {
  return (
    <div className="min-h-screen flex items-center justify-center pt-28 pb-16 bg-[#f3f4f6] px-4">
      <SEO title="403 - Adgang nægtet - Kokholm Byg" />

      <div className="max-w-md w-full bg-white border border-gray-200 rounded-lg p-8 sm:p-10 text-center shadow-sm space-y-6">
        <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto text-3xl font-extrabold">
          403
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-extrabold text-[#1e2329]">
            Der er ikke adgang til siden
          </h1>
          <p className="text-gray-600 text-sm leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne side.
          </p>
        </div>

        <div className="pt-4 border-t border-gray-100 flex flex-col gap-3 text-sm">
          <Link
            to="/"
            className="btn-cta py-3 px-5 font-semibold text-white rounded text-center shadow transition-all"
          >
            Gå til forsiden
          </Link>

          <Link
            to="/kontakt"
            className="py-2.5 px-5 font-semibold text-[#1e2329] bg-[#f3f4f6] hover:bg-gray-200 border border-gray-300 rounded text-center transition-colors"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
